import { render, staticRenderFns } from "./MatchHSGSRPLikelyReferral.vue?vue&type=template&id=1e48f974&"
import script from "./MatchHSGSRPLikelyReferral.vue?vue&type=script&lang=ts&"
export * from "./MatchHSGSRPLikelyReferral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports